module.exports = __webpack_public_path__ + "media/images/ih-cat-spinner-b5b049ff720d25cddd37aee6a128f237.svg";